// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"146":"FSFolder","161":"FSActivity","368":"KCNotFound","505":"FSBase"}[chunkId] || chunkId) + "-legacy." + {"146":"7cfa92ef","161":"d0e005ab","368":"ba810715","505":"0f707666","690":"efad67ca","843":"90cb8bef","937":"99b4e7b0"}[chunkId] + ".js";
};